export default function getCSRFToken() {
  return document.getElementById('csrf-token').getAttribute('content');
}
